import SessionDeleteModal from './SessionDeleteModal';

export default SessionDeleteModal;
